import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { Col, Form, Row, Select, Space, Button, DatePicker } from 'antd';
import { getById } from '../../../../apis/RolTurnoApi';
import { getEmpleadosActivos } from '../../../../apis/OdooApi';
import { getList as getHorarios } from '../../../../apis/OdooScheduleApi';
import { TIPO_DIA_OPTIONS } from '../../../../constants/tipoDia';
import { status_period } from '@app/constants/period';
import dayjs from 'dayjs';
import _ from 'lodash';

const { Option } = Select;

const FormBody = forwardRef(function FormBody({ onOk, onCancel, form, object, disabledForm, period, onEmpleadoChange }, ref) {
    const [ID, setID] = useState(null);
    const [disabled, setDisabled] = useState(disabledForm ?? false);
    const [initialValues, setInitialValues] = useState(null);
    const [empleados, setEmpleados] = useState([]);
    const [horarios, setHorarios] = useState([]);
    const [periodObject, setPeriodObject] = useState(period);

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getCatalogs();
            })();
        }
        return () => effectRan.current = true;
    }, []);

    useEffect(() => {
        if (period) {
            setPeriodObject(period);
        }
    }, [period]);

    useEffect(() => {
        (async () => {
            if (object?.id > 0) {
                setID(object.id);
                await refreshData(object.id);
            }
        })();
    }, [object]);

    useEffect(() => {
        (async () => {
            setDisabled(disabledForm)
        })();
    }, [disabledForm]);

    const refreshData = async (id) => {
        const response = await getById(id);
        if (response.ok) {
            let item = response.payload;
            // Convertir la fecha al formato dayjs
            const formattedItem = {
                empleado_id: item.empleado?.id || null,
                horario_id: item.horario?.id || null,
                tipo_dia: item.tipo_dia,
                fecha: item.fecha ? dayjs(item.fecha, 'YYYY-MM-DD') : null,
                periodo_id: item.periodo_id || null
            };
            setInitialValues(formattedItem);
            form.setFieldsValue(formattedItem);
        }
    }

    const getCatalogs = async () => {
        // Obtener empleados
        const responseEmpleados = await getEmpleadosActivos({ nomina_need_timesheets: true });
        if (responseEmpleados.ok) {
            let items = responseEmpleados.payload;
            setEmpleados(items);
        }

        // Obtener horarios
        const responseHorarios = await getHorarios();
        if (responseHorarios.ok) {
            let items = responseHorarios.payload.map(item => ({
                value: item.id,
                text: item.codigo_corto,
                id: item.id
            }));
            setHorarios(items);
        }
    }

    const onReset = () => {
        form.resetFields();
    };

    const onCancelBtn = async () => {
        if (onCancel) {
            await onCancel();
        }
    }

    const onFinish = async () => {
        await onOk();
    }

    return (
        <>
            <Form disabled={disabled}
                layout="vertical"
                form={form}
                requiredMark
                autoComplete="off"
                initialValues={{
                    empleado_id: null,
                    fecha: null,
                    horario_id: null,
                    tipo_dia: null,
                    periodo_id: null
                }}
                onFinish={onFinish}>
                <Row gutter={16}>
                    <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="empleado_id"
                            label="Empleado"
                            rules={[
                                {
                                    required: true,
                                    message: 'Selecciona un empleado',
                                },
                            ]}
                        >
                            <Select
                                placeholder="Por favor selecciona un empleado"
                                showSearch
                                optionFilterProp="children"
                                onChange={() => {
                                    if (onEmpleadoChange) {
                                        onEmpleadoChange();
                                    }
                                }}
                            >
                                {
                                    empleados.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="fecha"
                            label="Fecha"
                            rules={[
                                {
                                    required: true,
                                    message: 'Selecciona una fecha',
                                },
                            ]}
                        >
                            <DatePicker
                                placeholder="Selecciona una fecha"
                                format="DD/MM/YYYY"
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="horario_id"
                            label="Horario"
                            rules={[
                                {
                                    required: true,
                                    message: 'Selecciona un horario',
                                },
                            ]}
                        >
                            <Select
                                placeholder="Por favor selecciona un horario"
                                showSearch
                                optionFilterProp="children"
                            >
                                {
                                    horarios.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="tipo_dia"
                            label="Tipo Día"
                            rules={[
                                {
                                    required: true,
                                    message: 'Selecciona un tipo de día',
                                },
                            ]}
                        >
                            <Select placeholder="Por favor selecciona un tipo de día">
                                {
                                    TIPO_DIA_OPTIONS.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Space>
                        {
                            ID &&
                            <Button type="default" onClick={onCancelBtn}>
                                Cancelar
                            </Button>
                        }

                        <Button type="primary" htmlType="submit" disabled={!periodObject}>
                            Guardar
                        </Button>
                        <Button htmlType="button" onClick={onReset}>
                            Limpiar
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </>
    );
});

export default FormBody;